module.exports = __webpack_public_path__ + "static/media/calendar.97ff1500.svg";